<template>
  <div>
    <h2 class="text-xl font-semibold mb-4">Betalning</h2>

    <p class="text-gray-600 mb-4">
      Du betalar totalt <strong>{{ totalPrice }} kr</strong> för dina biljetter.
    </p>

    <div class="flex justify-between mt-4">
      <button
        class="px-4 py-2 bg-gray-200 rounded"
        @click="$emit('back')"
      >
        Tillbaka
      </button>
      <button
        class="px-4 py-2 bg-green-600 text-white rounded"
        @click="pay"
      >
        Betala med Stripe
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: ['event', 'buyer'],
  computed: {
    totalPrice() {
      return this.event.ticketTypes.reduce((sum, t) => {
        return sum + (t.selected || 0) * t.price;
      }, 0);
    },
  },
  methods: {
    async pay() {
      try {
        const res = await axios.post(`/api/events/${this.event._id}/checkout`, {
          tickets: this.event.ticketTypes.filter(t => t.selected > 0).map(t => ({
            name: t.name,
            quantity: t.selected,
            price: t.price
          })),
          buyer: {
            name: this.buyer.name || 'Okänd',
            email: this.buyer.email || 'test@example.com'
          }        
        });
        window.location = res.data.url; // Redirect to Stripe Checkout
      } catch (err) {
        console.error('Stripe error:', err);
      }
    }
  }
};
</script>
